import { useEffect } from "react";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { isStaffLinkSession } from "@/lib/staff-access-link";

export const Route = createFileRoute("/")({
  head: () => ({
    meta: [
      { title: "FutBux — Gestão de escolinhas de futebol" },
      {
        name: "description",
        content:
          "Entre no FutBux para gerenciar alunos, turmas, chamadas, planos e pagamentos da sua escolinha.",
      },
      { property: "og:title", content: "FutBux — Gestão de escolinhas de futebol" },
      {
        property: "og:description",
        content: "Gestão completa de alunos, turmas, chamadas, planos e pagamentos.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
  component: EntryRedirect,
});

/**
 * Entrada geral do app. Se a sessão atual deste navegador veio de um link de
 * colaborador (PIN), o link geral deve levar ao login — os links são
 * independentes e um não pode sequestrar o outro.
 */
function EntryRedirect() {
  const navigate = useNavigate();
  useEffect(() => {
    navigate({ to: isStaffLinkSession() ? "/auth" : "/dashboard", replace: true });
  }, [navigate]);
  return null;
}
